import { render, staticRenderFns } from "./SocialProofOrdersFilter.vue?vue&type=template&id=96be7104&"
import script from "./SocialProofOrdersFilter.vue?vue&type=script&lang=js&"
export * from "./SocialProofOrdersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports